type Positioned = {
  id: string;
  position: number;
};

export type Group<T extends Positioned> = {
  id: string;
  position: number;
  members: T[];
};

export const groupNearby = <T extends Positioned>(points: T[], mergeDistance: number): Group<T>[] => {
  const sorted = [...points].sort((a, b) => a.position - b.position);
  const groups: T[][] = [];
  for (const point of sorted) {
    const current = groups[groups.length - 1];
    if (current && point.position - current[0].position < mergeDistance) current.push(point);
    else groups.push([point]);
  }
  return groups.map(members => ({
    id: members.map(member => member.id).join(':'),
    position: members.reduce((total, member) => total + member.position, 0) / members.length,
    members,
  }));
};
